import {
  createBroker,
  createBrokerPartnership,
  createUser,
  updateBroker as editBroker,
  getBrokers,
  getBrokerAdmins,
  getAgencies,
  getPartners,
  getIntermediaries,
  getBankAgencies,
  getFilteredBrokerAgencies
} from '../utils/apiService';

export const CREATE_BROKER = 'broker/CREATE_BROKER';
export const CREATE_BROKER_PENDING = 'broker/CREATE_BROKER_PENDING';
export const CREATE_BROKER_FULFILLED = 'broker/CREATE_BROKER_FULFILLED';
export const CREATE_BROKER_REJECTED = 'broker/CREATE_BROKER_REJECTED';

export const CREATE_BROKER_PARTNER = 'broker/CREATE_BROKER_PARTNER';
export const CREATE_BROKER_PARTNER_PENDING =
  'broker/CREATE_BROKER_PARTNER_PENDING';
export const CREATE_BROKER_PARTNER_FULFILLED =
  'broker/CREATE_BROKER_PARTNER_FULFILLED';
export const CREATE_BROKER_PARTNER_REJECTED =
  'broker/CREATE_BROKER_PARTNER_REJECTED';

export const CREATE_ADMIN = 'broker/CREATE_ADMIN';
export const CREATE_ADMIN_PENDING = 'broker/CREATE_ADMIN_PENDING';
export const CREATE_ADMIN_FULFILLED = 'broker/CREATE_ADMIN_FULFILLED';
export const CREATE_ADMIN_REJECTED = 'broker/CREATE_ADMIN_REJECTED';

export const UPDATE_BROKER = 'broker/UPDATE_BROKER';
export const UPDATE_BROKER_PENDING = 'broker/UPDATE_BROKER_PENDING';
export const UPDATE_BROKER_FULFILLED = 'broker/UPDATE_BROKER_FULFILLED';
export const UPDATE_BROKER_REJECTED = 'broker/UPDATE_BROKER_REJECTED';

export const LIST_BROKERS = 'broker/LIST_BROKERS';
export const LIST_BROKERS_PENDING = 'broker/LIST_BROKERS_PENDING';
export const LIST_BROKERS_REJECTED = 'broker/LIST_BROKERS_REJECTED';
export const LIST_BROKERS_FULFILLED = 'broker/LIST_BROKERS_FULFILLED';

export const LIST_FILTERED_BROKERS = 'broker/LIST_FILTERED_BROKERS';
export const LIST_FILTERED_BROKERS_PENDING =
  'broker/LIST_FILTERED_BROKERS_PENDING';
export const LIST_FILTERED_BROKERS_REJECTED =
  'broker/LIST_FILTERED_BROKERS_REJECTED';
export const LIST_FILTERED_BROKERS_FULFILLED =
  'broker/LIST_FILTERED_BROKERS_FULFILLED';

export const LIST_BROKER_ADMINS = 'broker/LIST_BROKER_ADMINS';
export const LIST_BROKER_ADMINS_PENDING = 'broker/LIST_BROKER_ADMINS_PENDING';
export const LIST_BROKER_ADMINS_REJECTED = 'broker/LIST_BROKER_ADMINS_REJECTED';
export const LIST_BROKER_ADMINS_FULFILLED =
  'broker/LIST_BROKER_ADMINS_FULFILLED';

export const LIST_AGENCIES = 'broker/LIST_AGENCIES';
export const LIST_AGENCIES_PENDING = 'broker/LIST_AGENCIES_PENDING';
export const LIST_AGENCIES_REJECTED = 'broker/LIST_AGENCIES_REJECTED';
export const LIST_AGENCIES_FULFILLED = 'broker/LIST_AGENCIES_FULFILLED';

export const LIST_INTERMEDIARIES = 'broker/LIST_INTERMEDIARIES';
export const LIST_INTERMEDIARIES_PENDING = 'broker/LIST_INTERMEDIARIES_PENDING';
export const LIST_INTERMEDIARIES_REJECTED =
  'broker/LIST_INTERMEDIARIES_REJECTED';
export const LIST_INTERMEDIARIES_FULFILLED =
  'broker/LIST_INTERMEDIARIES_FULFILLED';

export const LIST_BANK_AGENCIES = 'broker/LIST_BANK_AGENCIES';
export const LIST_BANK_AGENCIES_PENDING = 'broker/LIST_BANK_AGENCIES_PENDING';
export const LIST_BANK_AGENCIES_REJECTED = 'broker/LIST_BANK_AGENCIES_REJECTED';
export const LIST_BANK_AGENCIES_FULFILLED =
  'broker/LIST_BANK_AGENCIES_FULFILLED';

export const LIST_PARTNERS = 'broker/LIST_PARTNERS';
export const LIST_PARTNERS_PENDING = 'broker/LIST_PARTNERS_PENDING';
export const LIST_PARTNERS_REJECTED = 'broker/LIST_PARTNERS_REJECTED';
export const LIST_PARTNERS_FULFILLED = 'broker/LIST_PARTNERS_FULFILLED';

export const saveBroker = broker => {
  const payload = createBroker(broker);
  return {
    type: CREATE_BROKER,
    payload
  };
};

export const saveBrokerPartnership = broker => {
  const payload = createBrokerPartnership(broker);
  return {
    type: CREATE_BROKER_PARTNER,
    payload
  };
};

export const updateBroker = broker => {
  const payload = editBroker(broker);
  return {
    type: UPDATE_BROKER,
    payload
  };
};

export const saveAdmin = broker => {
  const payload = createUser(broker);
  return {
    type: CREATE_ADMIN,
    payload
  };
};

export const listBrokers = filter => {
  const payload = getBrokers(filter);
  return {
    type: LIST_BROKERS,
    payload
  };
};
export const listFilteredBrokers = filter => {
  const payload = getBrokers(filter);
  return {
    type: LIST_FILTERED_BROKERS,
    payload
  };
};
export const listIntermediaries = () => {
  const payload = getIntermediaries();
  return {
    type: LIST_INTERMEDIARIES,
    payload
  };
};

export const listBankAgencies = () => {
  const payload = getBankAgencies();
  return {
    type: LIST_BANK_AGENCIES,
    payload
  };
};

export const listBrokerAdmins = () => {
  const payload = getBrokerAdmins();
  return {
    type: LIST_BROKER_ADMINS,
    payload
  };
};

export const listAgencies = () => {
  const payload = getAgencies();
  return {
    type: LIST_AGENCIES,
    payload
  };
};

export const listPartners = insurer => {
  const payload = getPartners(insurer);
  return {
    type: LIST_PARTNERS,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/brokers.js